var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarBigIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 60,
    viewBox: "0 0 57 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"calendar\""
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M37.3158 7.89474V2M37.3158 7.89474V13.7895M37.3158 7.89474H24.0526M1.94736 25.5789V52.1053C1.94736 55.3609 4.58652 58 7.84209 58H49.1053C52.3609 58 55 55.3609 55 52.1053V25.5789H1.94736Z",
    stroke: "#9E9E9E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.94736 25.579V13.7895C1.94736 10.5339 4.58652 7.89478 7.84209 7.89478H13.7368",
    stroke: "#9E9E9E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.7368 2V13.7895",
    stroke: "#9E9E9E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M55 25.579V13.7895C55 10.5339 52.3609 7.89478 49.1052 7.89478H47.6316",
    stroke: "#9E9E9E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBigIcon);
export default __webpack_public_path__ + "static/media/calendar-big-icon.4bd7da287eb0c3243941a52801872caf.svg";
export { ForwardRef as ReactComponent };